import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {PANEL_ID} from '@Panels/create-content-planner-event-panel/create-content-planner-event-panel';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useModalData} from '@Components/modal/hooks/useModalData';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {PANEL_SMALL_BREAKING_POINT} from '@Components/panel/panel.types';

export default function CreateEventModal(): ReactElement<any> | null {
  const modalData = useModalData(MODALS_IDS.CREATE_EVENT_MODAL);

  return (
    <Modal modalId={MODALS_IDS.CREATE_EVENT_MODAL} panelId={PANEL_ID} modalHeight="auto" modalWidth="100%" modalMaxWidth={`${PANEL_SMALL_BREAKING_POINT}px`}>
      <LazyPanel
        panelDirectoryName="create-content-planner-event-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
          modalId: MODALS_IDS.CREATE_EVENT_MODAL,
          dialogMode: true,
        }}
      />
    </Modal>
  );
}

export const openCreateEventModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CREATE_EVENT_MODAL,
      panelProps: {},
    })
  );
};
